export default __webpack_public_path__ + "static/media/button_deposit.f214bdfa.svg";